'use client';
import React, { useState, useMemo } from 'react';
import { BASE_FILE_URL } from '@/common/constants';
import { useTranslations } from 'next-intl';
import { formatDateVN } from '@/common/ultils';

export default function Modal({ row }) {
  const [isOpen, setIsOpen] = useState(false);

  const t = useTranslations('');

  const plainTextContent = useMemo(() => {
    if (typeof document === 'undefined') return '';
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = row.content || '';
    return tempDiv.textContent || tempDiv.innerText || '';
  }, [row.content]);

  const wordCount = plainTextContent.trim().split(/\s+/).length;
  const containerClass = `text-left ${wordCount < 100 ? 'flex' : ''}`;

  return (
    <>
      <button
        className="text-blue-600 underline hover:text-blue-800 p-1 
                   rounded-full hover:bg-gray-100 focus:outline-none focus:ring-2
                   focus:ring-offset-1 focus:ring-blue-500 cursor-pointer
                   "
        onClick={() => setIsOpen(true)}>
        {t('home.viewDetail')}
      </button>

      {isOpen && (
        <div className="fixed inset-0 bg-black/20 flex items-center justify-center z-50 overflow-y-auto h-full">
          <div className="bg-white p-6 rounded shadow-lg relative w-full max-w-[1280px] ">
            <button className="absolute top-2 right-2 text-[42px] cursor-pointer" onClick={() => setIsOpen(false)}>
              &times;
            </button>
            <h2 className="text-xl font-bold mb-4 text-red-600">{t('petitions.viewDetail.title')}</h2>
            <div className="text-left flex">
              <div className="w-[200px] font-semibold"> {t('petitions.viewDetail.code')}</div>: {row.code}
            </div>
            <div className="text-left flex">
              <div className="w-[200px] font-semibold"> {t('petitions.viewDetail.name')}</div>: {row?.name ?? ''}
            </div>
            <div className="text-left flex">
              <div className="w-[200px] font-semibold"> {t('petitions.viewDetail.type')}</div>: {row?.letterType?.name ?? ''}
            </div>
            <div className="text-left flex">
              <div className="w-[200px] font-semibold"> {t('petitions.viewDetail.senderType')}</div>: {row?.senderType?.name ?? ''}
            </div>
            <div className="text-left flex">
              <div className="w-[200px] font-semibold"> {t('petitions.viewDetail.submissionMethod')}</div>: {row?.sendMethod?.name ?? ''}
            </div>
            <div className="text-left flex">
              <div className="w-[200px] font-semibold"> {t('petitions.viewDetail.address')}</div>: {row?.address ?? ''}
            </div>
            <div className="text-left flex">
              <div className="w-[200px] font-semibold"> {t('petitions.viewDetail.receivedDate')}</div>:{formatDateVN(row?.dateOfReceipt)}
            </div>
            <div className="text-left flex">
              <div className="w-[200px] font-semibold"> {t('petitions.viewDetail.sender')}</div>: {row?.senderName}
            </div>
            <div className="text-left flex">
              <div className="w-[200px] font-semibold"> {t('petitions.viewDetail.attachments')}</div>:
              {row?.attachmentFileUrls.map((item) => (
                <a href={`${BASE_FILE_URL}/${item}`} key={item} alt="img" className="text-blue-500 italic underline w-[300px] truncate">
                  {item}
                </a>
              ))}
            </div>
            <div className="text-left flex">
              <div className="w-[200px] font-semibold">{t('petitions.viewDetail.note')}</div>: {row?.note ?? ''}
            </div>
            <div className={containerClass}>
              <div className="flex">
                <div className="w-[200px] font-semibold">{t('petitions.viewDetail.content')}</div> :
              </div>
              <div dangerouslySetInnerHTML={{ __html: row?.content ?? '' }} className="ml-[2px]" />
            </div>
          </div>
        </div>
      )}
    </>
  );
}
